export default __webpack_public_path__ + "static/media/pm-logo-dark.7c038bab.png";